import { render, staticRenderFns } from "./Thome.vue?vue&type=template&id=9de8cda4&scoped=true&"
import script from "./Thome.vue?vue&type=script&lang=js&"
export * from "./Thome.vue?vue&type=script&lang=js&"
import style0 from "./Thome.vue?vue&type=style&index=0&id=9de8cda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de8cda4",
  null
  
)

export default component.exports